import React from 'react';
import _ from 'lodash';
import { styled } from '@this/constants/themes';
import { media } from '@this/components/shared/atoms/media';
import type { TripUpdateResponse } from '@this/domain/trip/trip';

import { Fetcher } from '@this/src/util/fetcher';

interface Props {
  trip: any;
  serviceId: number;
  apiTotalPrice: number;
}

class TripReceiptCardHead extends React.Component<Props> {
  handleChangeInternalNumber = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { trip } = this.props;
    trip.setInternalNumber(e.target.value);
  };

  handleSubmitInternalNumber = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const { trip } = this.props;
    const params = { internal_number: trip.internalNumber };
    try {
      const res = await Fetcher.put<TripUpdateResponse>(`trips/${trip.id}/internal_number`, params);
      if (res.success) {
        alert('社内管理番号を保存しました');
      } else {
        alert(res.errors);
      }
    } catch {
      alert('通信環境が不安定です。\n時間をおいてもう一度お試しください。');
    }
  };

  render() {
    const { trip, serviceId, apiTotalPrice } = this.props;
    return (
      <>
        <StyledHeadText>
          <StyledHeadTitle>
            旅程番号：<span data-wovn-ignore>{`${trip.id} (${trip.dateRange()})`}</span>
          </StyledHeadTitle>
          <StyledHeadSmall title={trip.originTitle()}>
            出発地：<span data-wovn-ignore>{`${trip.originText()}`}</span>
          </StyledHeadSmall>
          <StyledHeadSmall title={trip.destinationTitle()}>
            目的地：<span data-wovn-ignore>{trip.destinationText()}</span>
          </StyledHeadSmall>
          {utils.isTabikobo(serviceId) && (
            <StyledHeadForm onSubmit={this.handleSubmitInternalNumber}>
              <span>社内管理番号：</span>
              <input type="text" value={trip.internalNumber || ''} onChange={this.handleChangeInternalNumber} />
              <button type="submit">保存</button>
            </StyledHeadForm>
          )}
          <StyledHeadSmall title={trip.createdAt('YYYY/MM/DD HH:mm')}>
            旅程作成日時：<span data-wovn-ignore>{trip.createdAt('YYYY/MM/DD HH:mm')}</span>
          </StyledHeadSmall>
        </StyledHeadText>
        <StyledHeadStatusGroup>
          <StyledHeadStatusBlock>
            <StyledTotalPrice>
              <span>合計</span>
              <span data-wovn-ignore>{utils.digits(apiTotalPrice)}</span>
              <span>円</span>
            </StyledTotalPrice>
          </StyledHeadStatusBlock>
        </StyledHeadStatusGroup>
      </>
    );
  }
}

const StyledHeadText = styled.div`
  margin: auto 0;
`;

const StyledHeadTitle = styled.p`
  font-size: 14px;
  font-weight: bold;
  line-height: 2;

  ${media.sp`
    font-size: 12px;
  `}
`;

const StyledHeadSmall = styled.p`
  color: ${props => props.theme.disabledColor};
  font-size: 11px;
  line-height: 1.6;

  ${media.sp`
    font-size: 10px;
  `}
`;

const StyledHeadForm = styled.form`
  display: flex;
  margin-top: 5px;
  @media screen and (max-width: 485px) {
    flex-wrap: wrap;
  }

  & span {
    line-height: 30px;
    width: 200px;
  }

  & input {
    margin: 0 5px;
  }

  & button {
    height: fit-content;
  }
`;

const StyledHeadStatusGroup = styled.form`
  margin-left: auto;
`;

const StyledHeadStatusBlock = styled.div`
  display: flex;
  align-items: center;
  margin-top: 5px;
  gap: 10px;
`;

const StyledTotalPrice = styled.p`
  color: ${props => props.theme.textColor};
  font-weight: bold;
`;

export default TripReceiptCardHead;
